module.exports = __webpack_public_path__ + "static/media/jobmatch.4725fcb4.svg";